/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitioncount1Inputs */

const de__field_acquisitioncount1 = /** @type {(inputs: _Field_Acquisitioncount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl OS-Akquise`)
};

/**

* @param {_Field_Acquisitioncount1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitioncount1 = /** @type {((inputs?: _Field_Acquisitioncount1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitioncount1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitioncount1(inputs)
});
export { _field_acquisitioncount1 as "_field_acquisitionCount" }